var customersPerHourTooltipTemplate = require('html/templates/customersPerHourTooltip')();
var util = require('js/lib/util');
var t = require('js/lib/translate').t;

planCtrl.$inject = ['$scope', '$rootScope', '$routeParams', '$location',
                    '$controller', 'load', 'config', 'editRoutePlan'];

function planCtrl($scope, $rootScope, $routeParams, $location,
                  $controller, load, config, editRoutePlan) {

  $controller('commonCtrl', { $scope: $scope });

  $scope.customersPerHourTooltipTemplate = customersPerHourTooltipTemplate;
  $scope.routeColors = config.routeColors;

  $scope.getOptimizeStopsLimit = function() { return 3500; }; // Limit stops to prevent Spider-problems

  var loadData = function(routePlanId) {
    load.routePlans();
    if (routePlanId) {
      load.routePlan(routePlanId).then(function(data) {
        load.drivers(data.companyId);
        load.customerSystemsForCompany(data.companyId);
      });
    } else {
      load.customerSystems();
      $scope.routePlan = null;
    }

    $scope.loadCommonData();
  };

  if ($rootScope.auth) {
    loadData($routeParams.routePlanId);
  }

  $scope.dataLoaded = function() {
    if (! $rootScope.auth) return true;
    if (! $scope.commonDataLoaded()) return false;

    if ($routeParams.routePlanId) {
      return $scope.routePlans && $scope.routePlan && $scope.routePlan.id === +$routeParams.routePlanId &&
             $scope.customerSystems && $scope.drivers && true;
    } else {
      return $scope.routePlans && $scope.customerSystems && $scope.driverUsers && $scope.users && true;
    }
  };


  $scope.archive = $location.hash() === 'archive';

  // EditRoutePlan-service (mappings)
  $scope.openEditRoutePlan = editRoutePlan.openEditRoutePlan.bind(this, $scope);
  $scope.saveRoutePlan = editRoutePlan.saveRoutePlan.bind(this, $scope);
  $scope.deleteRoutePlan = editRoutePlan.deleteRoutePlan.bind(this, $scope);

  $scope.exportInvoiceDataAllPlansUrl = function() {
    return $scope.baseUrl + '/pl/api/v-1/export/invoiceData?token=' + $rootScope.auth.token;
  };

  $scope.exportCompanyDeliveriesDataUrl = function() {
    return $scope.baseUrl + '/pl/api/v-1/export/companyDeliveriesData/' + $rootScope.auth.companyId + '?token=' + $rootScope.auth.token;
  };

  $scope.exportGeoFenceMetaUrl = function() {
    return $scope.baseUrl + '/pl/api/v-1/export/geoFencingMeta/' + $rootScope.auth.companyId + '?token=' + $rootScope.auth.token;
  };

  $scope.customerSystemNames = function(customerSystemIds) {

    var name = function(id) {
      return ($scope.customerSystems[id] || {}).name;
    };

    return (customerSystemIds || [])
      .map(name)
      .filter(Boolean) // The routePlan may contain customerSystems not included in $scope.customerSystems
      .sort();
  };

  $scope.canDeleteFiles = function(routePlan) {
    return routePlan.editable() &&
      ($rootScope.auth.roles.plannerPlus || ($rootScope.auth.roles.clientPlus && routePlan.hasAccessToAllCustomerSystems($rootScope.auth.customerSystemIds))
    );
  };

}

module.exports = planCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/controllers/planCtrl.js
 ** module id = 130
 ** module chunks = 1
 **/